// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".zmdl-inner-container{position:relative;width:80vw;height:90vh;border-radius:7px;background-color:#fff;z-index:1000;pointer-events:auto}.zmdl-inner-container>.zmdl-close-btn{width:32px;height:32px;border-radius:100%;position:relative;top:-16px;left:calc(100% - 16px);display:flex;align-items:center;justify-content:center;background-color:#f2f2f2}.zmdl-inner-container>.zmdl-close-btn:hover{cursor:pointer}.zmdl-inner-container>.zmdl-close-btn>svg{pointer-events:none}", ""]);
// Exports
module.exports = exports;
